import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import vuetify from "./plugins/vuetify";
import "vuetify/dist/vuetify.min.css";
import "./style.css";

import axios from "./axios";
import { PiniaVuePlugin, createPinia } from "pinia";
import { useGameStore } from "@/stores/game";

Vue.config.productionTip = false;
Vue.config.devtools = false;

Vue.use(PiniaVuePlugin);

const pinia = createPinia();
const store = useGameStore(pinia);

store.loadAuthFromStorage();

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      if (router.currentRoute.path !== "/login") {
        store.logout();
        router.push("/login");
      }
    }

    return Promise.reject(error);
  }
);

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "Electroliga";
  next();
});

new Vue({
  router,
  pinia,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");